import React from "react";
import ncludeLogo from "../assets/nclude.svg";

const BenefitsBrandPanel = () => (
  <section className="benefits-brand-panel" aria-labelledby="benefits-brand-heading">
    <img className="benefits-brand-logo" src={ncludeLogo} alt="NClude" />

    <div className="benefits-brand-copy">
      <p className="benefits-brand-eyebrow">Benefits screening</p>
      <h1 id="benefits-brand-heading">
        Billions in benefits go <em>unclaimed</em> every year.
      </h1>
      <p className="benefits-brand-summary">
        Answer a few guided questions about your household, work, and income.
        Get back a plain-language report of the federal and state programs that
        may match your situation.
      </p>
    </div>

    {/* <dl className="benefits-brand-stats" aria-label="Benefits screening facts">
      <div>
        <dt>64,000+</dt>
        <dd>people served</dd>
      </div>
      <div>
        <dt>50 states</dt>
        <dd>plus DC and territories</dd>
      </div>
      <div>
        <dt>About 8 min</dt>
        <dd>typical screening</dd>
      </div>
    </dl> */}
  </section>
);

export default BenefitsBrandPanel;
